/**
 * Shared inline/block error panel — presentation only.
 *
 * Consumers (S1): ProtectedRoute (role denial), DeviceDetail (not found)
 *
 * Contract:
 * - Caller supplies message and optional action node.
 * - Default layout is a centered block; `className` preserves page-specific wrappers.
 * - No routing, auth checks, or API calls.
 */
export function ErrorState({
  message,
  action,
  className = 'p-6 text-center',
  messageClassName = 'text-xl text-ops-alarm',
  asMessage: MessageTag = 'div',
}) {
  return (
    <div className={className}>
      <MessageTag className={messageClassName}>{message}</MessageTag>
      {action}
    </div>
  );
}
